import { useEffect, useState } from 'react';
import {
    getPeriodicCheckQueueVersion,
    subscribePeriodicCheckQueue,
} from '~/data/sync/periodicCheckQueue';
import { listQueuedIssues, pendingIssueKeyMap } from '~/data/sync/issueQueue';
import { useStoreState } from '~/store';

export function usePendingIssues(
    targets: { id?: string | number | null; guid?: string | null }[] = [],
): { pending: Record<string, true>; loaded: boolean } {
    const userId = useStoreState(state => state.user.data?.id);
    const [queueVersion, setQueueVersion] = useState(getPeriodicCheckQueueVersion);
    const [pending, setPending] = useState<Record<string, true>>({});
    const [loaded, setLoaded] = useState(false);
    const targetKey = targets.map(target => `${target.id ?? ''}:${target.guid ?? ''}`).join('|');

    useEffect(() => subscribePeriodicCheckQueue(setQueueVersion), []);

    useEffect(() => {
        let cancelled = false;
        if (!userId || !window.sqlitePlugin) {
            setPending({});
            setLoaded(true);
            return;
        }
        listQueuedIssues(Number(userId)).then(rows => {
            if (cancelled) {
                return;
            }
            setPending(pendingIssueKeyMap(rows));
            setLoaded(true);
        }).catch(() => {
            if (!cancelled) {
                setPending({});
                setLoaded(true);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [userId, targetKey, queueVersion]);

    return { pending, loaded };
}
